<template>
    <div class="pre-reg-dropdown">
        <label class="pre-reg-dropdown__label" :for="heading">{{ heading }}</label>
        <div class="dropdown">
            <select
                @change="$emit('change', selected)"
                class="pre-reg-dropdown__select"
                :name="heading"
                :class="{ '-is-disabled' : disabled }"
                :disabled="disabled"
                :placeholder="heading"
                v-model="selected"
            >
                <option
                    :value="null"
                    selected="selected"
                    v-text="heading"
                    disabled
                />
                <option
                    v-for="(item, key) in sortedOptions"
                    :value="item"
                    :key="key"
                    v-text="item.title"
                />
            </select>
        </div>
    </div>
</template>

<script>
export default {
    props: ['heading', 'category', 'options', 'disabled'],
    watch: {
        options(options) {
            let sortedOptions = this.options.slice(0);

            this.selected = null;

            sortedOptions.sort((a, b) => (a.title > b.title) ? 1 : ((b.title> a.title) ? -1 : 0));

            this.sortedOptions = sortedOptions;
        }
    },
    data: () => ({
        selected: null,
        sortedOptions: {},
    }),
}
</script>
